import { Container, Row, Col} from 'react-bootstrap';
import '../assets/styles/directory.css';

const FormContainer = ({children}) => {
  return (
    <Container>
        <Row className="justify-content-md-center">
            <Col xs={12} md={6}>
                <div className="modern-form-card">
                    {children}
                </div>
            </Col>
        </Row>
    </Container>
  )
}

export default FormContainer;
